import { getRedirectResult, User, UserCredential } from "firebase/auth";
import { auth, handleLogin } from "@/app/firebase/auth";

async function handleRedirectResult(): Promise<UserCredential | null> {
  const initialUser = auth.currentUser;
  if (initialUser) {
    // console.log("User signed in:", initialUser);
    return null;
  }

  // No user exists in the app's auth state, check the redirect result
  try {
    const redirectResult = await getRedirectResult(auth);
    if (redirectResult?.user) {
      // console.log("User signed in:", redirectResult.user);
      // console.log("User credential from redirect:", redirectResult);
      return redirectResult;
    } else if (window.location.hostname !== "localhost") {
      await handleLogin();
    }
  } catch (error) {
    console.error("Error during sign-in:", error);
  }

  return null;
}

function getUserInitials(user: User | undefined): string {
  let userInitials = "";
  if (user != undefined) {
    user.displayName?.split(" ").forEach((name) => {
      userInitials = userInitials + name[0];
    });
  }
  return userInitials;
}

function getUserId(email: string): string | null {
  const match = email.match(/^([^@]+)@/);
  return match ? match[1] : null;
}

export { handleRedirectResult, getUserInitials, getUserId };
